import React, { useEffect } from "react";
import { connect } from "react-redux";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/wallet.css";
import { GetWalletHistoryAction } from "../../redux/actions/wallet";
import moment from "moment";
import config from "../../config";
import { Link } from "react-router-dom";
import { GetInfo } from "../../redux/actions/auth";

const Wallet = ({ auth, wallet, getWallet, getInfo }) => {
    useEffect(() => {
        getInfo().then(() => {
            getWallet().then();
        });
    }, []);

    return (
        <>
            <Header />
            <section className="wallet_sec">
                <div className="container">
                    <div className="tobar">
                        <div className="heading">
                            <h3>Wallet</h3>
                        </div>
                        <div className="total_payment">
                            <div className="flx">
                                <div className="icon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-wallet"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5V3zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a1.99 1.99 0 0 1-1-.268zM1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1z" />
                                    </svg>
                                </div>
                                <div className="heading">
                                    <h3>${auth.user.wallet}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {wallet.map((singleHistory) => {
                        let content = (
                            <div className="wallert_wrapper">
                                <div className="left_wrapper">
                                    {/* <div className="img_box">
                                    <figure>
                                        <img
                                            src={require("../../assets/img/services/hand.png")}
                                            className="img-fluid"
                                        />
                                    </figure>
                                </div> */}
                                    <div className="name">
                                        <h4>
                                            {config.caiptalize(
                                                singleHistory.type
                                            )}
                                        </h4>
                                        <p>
                                            {moment(
                                                singleHistory.created_at
                                            ).format("DD MMMM, YYYY")}
                                        </p>
                                    </div>
                                </div>
                                <div className="right_wrapper">
                                    <h4 className="price">
                                        ${singleHistory.amount}
                                    </h4>
                                    {/* <p className="status">pending</p> */}
                                </div>
                            </div>
                        );
                        if (singleHistory.job_id) {
                            return (
                                <Link
                                    to={`/job-detail/${singleHistory.job_id}`}
                                >
                                    {content}
                                </Link>
                            );
                        } else {
                            return content;
                        }
                    })}
                </div>
                {/* </div> */}
            </section>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    wallet: state.wallet,
});

const mapDispatchToProps = (dispatch) => ({
    getWallet: async () => dispatch(await GetWalletHistoryAction()),
    getInfo: async () => dispatch(await GetInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Wallet);
